module.exports = __webpack_public_path__ + "img/cooperation.3820998b.png";